
type MenuIcon = {
    active?: boolean;
    action?: (param?: any) => void
}


export function OptionIcon({ active = false, action }: MenuIcon) {
    return (
        <svg
            width="22" height="22" viewBox="0 0 21 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={() => action && action()}
        >
            <path d="M3 2.75C2.57812 2.75 2.25 3.125 2.25 3.5V18.5C2.25 18.9219 2.57812 19.25 3 19.25H18C18.375 19.25 18.75 18.9219 18.75 18.5V3.5C18.75 3.125 18.375 2.75 18 2.75H3ZM0 3.5C0 1.85938 1.3125 0.5 3 0.5H18C19.6406 0.5 21 1.85938 21 3.5V18.5C21 20.1875 19.6406 21.5 18 21.5H3C1.3125 21.5 0 20.1875 0 18.5V3.5ZM4.5 6.5C4.5 5.70312 5.15625 5 6 5C6.79688 5 7.5 5.70312 7.5 6.5C7.5 7.34375 6.79688 8 6 8C5.15625 8 4.5 7.34375 4.5 6.5ZM9.375 6.5C9.375 5.89062 9.84375 5.375 10.5 5.375H15C15.6094 5.375 16.125 5.89062 16.125 6.5C16.125 7.15625 15.6094 7.625 15 7.625H10.5C9.84375 7.625 9.375 7.15625 9.375 6.5ZM9.375 11C9.375 10.3906 9.84375 9.875 10.5 9.875H15C15.6094 9.875 16.125 10.3906 16.125 11C16.125 11.6562 15.6094 12.125 15 12.125H10.5C9.84375 12.125 9.375 11.6562 9.375 11ZM9.375 15.5C9.375 14.8906 9.84375 14.375 10.5 14.375H15C15.6094 14.375 16.125 14.8906 16.125 15.5C16.125 16.1562 15.6094 16.625 15 16.625H10.5C9.84375 16.625 9.375 16.1562 9.375 15.5ZM6 12.5C5.15625 12.5 4.5 11.8438 4.5 11C4.5 10.2031 5.15625 9.5 6 9.5C6.79688 9.5 7.5 10.2031 7.5 11C7.5 11.8438 6.79688 12.5 6 12.5ZM4.5 15.5C4.5 14.7031 5.15625 14 6 14C6.79688 14 7.5 14.7031 7.5 15.5C7.5 16.3438 6.79688 17 6 17C5.15625 17 4.5 16.3438 4.5 15.5Z" fill="#6E7586" />
        </svg>

    )
}